import playerServiceCreator from '@services/player-service'
import queueServiceCreator from '@services/queue-service'
import keyControlsServiceCreator from '../../services/key-controls-service'

const playerService = playerServiceCreator()
const queueService = queueServiceCreator({ playerService })
const keyControlsService = keyControlsServiceCreator(playerService, queueService)

export const state = {
    queueService,
    playerService,
    keyControlsService,
}

export const getters = {}

export const mutations = {}

export const actions = {}
